var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"committees"},_vm._l((_vm.committees),function(committee){return _c('Committee',{key:committee.id,attrs:{"name":committee.name,"about":committee.about,"email":committee.email}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }